import { AuthGuard } from '@repo/user-session';
import { SignBackButtonLayout, WithdrawConfirmContent } from '@repo/user-sign';
import { ReactElement } from 'react';

const WithdrawConfirmPage = () => {
  return <WithdrawConfirmContent />;
};

WithdrawConfirmPage.getLayout = (page: ReactElement) => (
  <AuthGuard>
    <SignBackButtonLayout>{page}</SignBackButtonLayout>
  </AuthGuard>
);

export default WithdrawConfirmPage;
